<template>
  <div>
    <Head :title="__(title)" />
    <div class="flex flex-col md:flex-row gap-3 mb-4 justify-between items-center ticket-filters">
      <search-input v-model="form.search" class="w-full max-w-md search" @reset="reset"></search-input>
      <div class="filter-add-new flex flex-col gap-3 md:flex-row items-center">
        <a
          v-if="user_access.asset.export"
          class="uppercase gap-[1px] text-sm px-3 py-2 flex items-center justify-center"
          href="/dashboard/asset_management/assets/export/excel"
        >
          <img class="w-6 h-6" src="/images/svg/export-csv.svg" alt="Export CSV" />
          <span>{{ __('Export') }}</span>
        </a>
        <label
          v-if="user_access.asset.import"
          for="importCSV"
          class="uppercase gap-[1px] text-sm px-3 py-2 flex items-center justify-center"
        >
          <img class="w-6 h-6" src="/images/svg/import-csv.svg" alt="Import CSV" />
          <span>{{ __('Import') }}</span>
          <input @change="uploadImportCSV" class="hidden" id="importCSV" type="file" />
        </label>
        <button
          v-if="user_access.asset.import"
          class="gap-[1px] text-sm px-3 py-2 flex items-center justify-center"
          @click="downloadTemplateExcel"
        >
          <img class="w-6 h-6" src="/images/svg/export-csv.svg" alt="Export CSV" />
          <span>{{ __('Download Template') }}</span>
        </button>
        <select
          v-model="form.limit"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <Link
          v-if="user_access.asset.create"
          class="btn-indigo"
          :href="this.route('assets.create')"
        >
          <span>{{ __('Create a New Asset') }}</span>
        </Link>
      </div>
    </div>

    <div class="flex flex-col gap-3 mb-4 md:flex-row w-full items-center ticket-filters">
      <div class="mr-2 w-full">{{ __('Filter Asset By') }}:</div>
      <!-- <select-input v-model="form.type_id" class="mr-2 w-full">
        <option :value="null">{{ __('Type') }}</option>
        <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>-->
      <select-input-filter
        :placeholder="__('Type')"
        :onInput="doFilter"
        @focus="doFilter"
        :items="types"
        v-model="form.type_id"
        class="w-full"
      ></select-input-filter>
      <select-input v-model="form.category_id" class="mr-2 w-full">
        <option :value="null">{{ __('Category') }}</option>
        <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>
      <select-input v-model="form.brand_id" class="mr-2 w-full">
        <option :value="null">{{ __('Brand') }}</option>
        <option v-for="s in brands" :key="s.id" :value="s.id">{{ s.name }}</option>
      </select-input>
      <select-input v-model="form.status" class="mr-2 w-full">
        <option :value="null">{{ __('Status') }}</option>
        <option v-for="s in statuses" :key="s.value" :value="s.value">{{ s.label }}</option>
      </select-input>
      <Link class="btn-indigo" :href="this.route('assets')">
        <span>{{ __('Reset Filter') }}</span>
      </Link>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto relative">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">#{{ __('ID') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Code') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Type') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Serial Number') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Brand') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Category') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Status') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Join Date') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(asset, index) in assets.data"
            :key="index"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >{{ (assets.current_page - 1) * assets.per_page + index + 1 }}</Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >{{ asset.code }}</Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >{{ asset.type }}</Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >{{ asset.serial_number }}</Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >{{ asset.brand }}</Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >{{ asset.category }}</Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >
                <span
                  :class="['px-2 py-1 rounded-full text-white font-bold', asset.status === 'available' ? 'bg-green-500' : asset.status === 'damaged' ? 'bg-yellow-500 text-black' : asset.status === 'inden_part' ? 'bg-gray-500' : asset.status === 'sold' ? 'bg-orange-500' : asset.status === 'outgoing' ? 'bg-red-500' : 'bg-red-500']"
                >
                  <!-- Text for each status -->
                  {{ asset.status === 'available' ? 'Available' : asset.status === 'damaged' ? 'Damaged' : asset.status === 'inden_part' ? 'Inden Part' : asset.status === 'sold' ? 'Sold' : asset.status === 'outgoing' ? 'Outgoing' : 'Unknown' }}
                </span>
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('assets.show', asset.id)"
              >{{ asset.join_date }}</Link>
            </td>
            <td class="border-t w-px relative">
              <div class @click.stop="toggleDropdown(asset.id)">
                <button class="px-4 flex items-center justify-start space-x-4" tabindex="-1">
                  <icon name="dots-vertical" class="block w-5 h-5" />
                </button>
                <div
                  v-if="dropdownOpen[asset.id]"
                  class="z-50 mt-2 right-0 w-48 bg-white rounded-md shadow-lg"
                  :style="{ top: '100%' }"
                >
                  <Link
                    v-if="user_access.asset.update"
                    :href="this.route('assets.edit', asset.id)"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >Edit</Link>
                  <Link
                    v-if="user_access.asset.read"
                    :href="this.route('assets.show', asset.id)"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >Detail</Link>
                  <button
                    v-if="user_access.asset.delete"
                    @click="deleteAsset(asset.id)"
                    class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >Delete</button>
                  <Link
                    v-if="user_access.asset.update"
                    :href="this.route('assets.service_create', asset.id)"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >Services</Link>
                  <Link
                    v-if="user_access.asset.update"
                    :href="this.route('assets.change_part_create', asset.id)"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >Change Part</Link>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="assets.data.length === 0">
            <td class="border-t px-6 py-4" colspan="10">No asset found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination class="mt-6" :links="assets.links" />
  </div>
</template>


  <script>
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'
import axios from 'axios'
import SelectInputFilter from '@/Shared/SelectInputFilter'

const statuses = [
  {
    value: 'available',
    label: 'Available',
  },
  {
    value: 'outgoing',
    label: 'Outgoing',
  },
  {
    value: 'inden_part',
    label: 'Inden Part',
  },
  {
    value: 'damaged',
    label: 'Damaged',
  },
  {
    value: 'sold',
    label: 'Sold',
  },
]

export default {
  metaInfo: { title: 'Assets' },
  components: {
    Icon,
    Link,
    Head,
    Pagination,
    SearchInput,
    SelectInput,
    SelectInputFilter,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
    assets: Object,
    types: Array,
    categories: Array,
    brands: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        limit: this.filters.limit ?? 10,
        category_id: this.filters.category_id ?? null,
        brand_id: this.filters.brand_id ?? null,
        type_id: this.filters.type_id ?? null,
        status: this.filters.status ?? null,
      },
      user_access: this.$page.props.auth.user.access,
      dropdownOpen: {}, // Track open/close state of each dropdown
      statuses: statuses,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('assets'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  mounted() {
    document.addEventListener('click', this.closeAllDropdowns)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeAllDropdowns)
  },
  methods: {
    doFilter(e) {
      axios.get(this.route('filter.type_asset', { search: e.target.value })).then((res) => {
        this.types.splice(0, this.types.length, ...res.data)
      })
    },
    toggleDropdown(id) {
      this.dropdownOpen = { ...this.dropdownOpen, [id]: !this.dropdownOpen[id] }
    },
    closeAllDropdowns() {
      this.dropdownOpen = {}
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    deleteAsset(id) {
      if (confirm('Are you sure you want to delete this asset?')) {
        this.$inertia.delete(this.route('assets.destroy', id))
      }
    },
    uploadImportCSV(e) {
      if (e.target.files.length) {
        this.$inertia.form({ file: e.target.files[0] }).post(this.route('assets.import_excel'))
      }
    },
    downloadTemplateExcel() {
      const link = document.createElement('a')
      link.href = '/template_excel/asset_template_import.xlsx' // Path to the template file
      link.download = 'asset_template_import.xlsx' // Name the file as you want
      link.click()
    },
  },
}
</script>
